export const KA_CATEGORIES = {
  secureCoding: "secure-coding",
  coreSecurityConcepts: "core-security-concepts",
  secureDevelopment: "secure-development",
  aiLlm: "ai-llm",
  aiFoundations: "ai-foundations",
  aiSkillsAndWorkflows: "ai-skills-and-workflows",
  aiAgents: "ai-agents",
};

// Canonical display order for assessment sections on admin (also used as keys elsewhere)
export const KA_CATEGORY_ORDER: string[] = [
  KA_CATEGORIES.secureCoding,
  KA_CATEGORIES.coreSecurityConcepts,
  KA_CATEGORIES.secureDevelopment,
  KA_CATEGORIES.aiLlm,
  KA_CATEGORIES.aiFoundations,
  KA_CATEGORIES.aiSkillsAndWorkflows,
  KA_CATEGORIES.aiAgents,
];

export const categoryEstimationConfig: Record<
  string,
  { questions: number; estFinishTime: string }
> = {
  [KA_CATEGORIES.secureCoding]: {
    questions: 10,
    estFinishTime: "15 - 25",
  },
  [KA_CATEGORIES.coreSecurityConcepts]: {
    questions: 11,
    estFinishTime: "10 - 15",
  },
  [KA_CATEGORIES.secureDevelopment]: {
    questions: 13,
    estFinishTime: "15 - 25",
  },
  [KA_CATEGORIES.aiLlm]: {
    questions: 12,
    estFinishTime: "15 - 25",
  },
  [KA_CATEGORIES.aiFoundations]: {
    questions: 10,
    estFinishTime: "10 - 15",
  },
  [KA_CATEGORIES.aiSkillsAndWorkflows]: {
    questions: 6,
    estFinishTime: "5 - 15",
  },
  [KA_CATEGORIES.aiAgents]: {
    questions: 6,
    estFinishTime: "5 - 15",
  },
};

// Every section is multiple choice except Secure Coding, which has hands-on coding questions.
export const getKaQuestionTypeLabel = (sectionPath: string): string =>
  sectionPath === KA_CATEGORIES.secureCoding
    ? "Hands-on coding questions"
    : "Multiple choice questions";
